export const BalanceSheetTableFilterData = [
    {
        "idFromColumnFilter": "nameMaterial",
        "id": "nameMaterial",
    },
    {
        "idFromColumnFilter": "unit",
        "id": "unit",
    },
    {
        "idFromColumnFilter": "startQuantity",
        "id": "startQuantity",
    },
    {
        "idFromColumnFilter": "arrivalQuantity",
        "id": "arrivalQuantity",
    },
    {
        "idFromColumnFilter": "issuanceQuantity",
        "id": "issuanceQuantity",
    },
    {
        "idFromColumnFilter": "endQuantity",
        "id": "endQuantity",
    },
    {
        "idFromColumnFilter": "startAmountBasePrice",
        "id": "startAmountBasePrice",
    },
    {
        "idFromColumnFilter": "arrivalAmountBasePrice",
        "id": "arrivalAmountBasePrice",
    },
    {
        "idFromColumnFilter": "issuanceAmountBasePrice",
        "id": "issuanceAmountBasePrice",
    },
    {
        "idFromColumnFilter": "endAmountBasePrice",
        "id": "endAmountBasePrice",
    },
    {
        "idFromColumnFilter": "startAmountAlternativePrice",
        "id": "startAmountAlternativePrice",
    },
    {
        "idFromColumnFilter": "arrivalAmountAlternativePrice",
        "id": "arrivalAmountAlternativePrice",
    },
    {
        "idFromColumnFilter": "issuanceAmountAlternativePrice",
        "id": "issuanceAmountAlternativePrice",
    },
    {
        "idFromColumnFilter": "endAmountAlternativePrice",
        "id": "endAmountAlternativePrice",
    },
]